// App-wide render-crash safety net. Without this, ANY uncaught render error
// (e.g. React #310 hooks-order violations) unmounts the whole tree and the
// customer sees a blank white screen. This catches it and shows a recovery
// card with a Reload button instead — and logs the real error + component
// stack so the crash can be diagnosed (readable once sourcemaps are on).
import { Component, type ReactNode } from 'react';

interface Props { children: ReactNode }
interface State { hasError: boolean; error: Error | null }

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: { componentStack: string }) {
    // Surfaced in the console + available for any logging hook we add later.
    console.error('[ErrorBoundary] render crash:', error?.message, error?.stack, info?.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div
        style={{
          minHeight: '100vh', display: 'flex', flexDirection: 'column',
          alignItems: 'center', justifyContent: 'center', padding: 24,
          textAlign: 'center', background: '#FBF7EF',
        }}
      >
        <div style={{ fontSize: 40, marginBottom: 12 }}>😕</div>
        <h1 style={{ fontSize: 18, fontWeight: 700, color: '#1f2937', marginBottom: 8 }}>
          Une erreur est survenue
        </h1>
        <p style={{ fontSize: 14, color: '#6b7280', maxWidth: 340, marginBottom: 20, lineHeight: 1.5 }}>
          L'éditeur a rencontré un problème inattendu. Rechargez la page — vos
          modifications récentes sont sauvegardées automatiquement.
        </p>
        <button
          onClick={() => window.location.reload()}
          style={{
            background: '#C9A24A', color: '#fff', fontWeight: 600,
            padding: '10px 24px', borderRadius: 999, border: 'none',
            fontSize: 14, cursor: 'pointer',
          }}
        >
          Recharger la page
        </button>
      </div>
    );
  }
}
